import { createApp } from 'vue';
import App from './App.vue';
import pinia from './store/';
import router from './router'; // 引入剛建立的路由
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import 'bootstrap/dist/css/bootstrap.css';
const app = createApp(App);
app.use(pinia);
app.use(router); // 使用 Vue Router
app.component('EasyDataTable', Vue3EasyDataTable);
app.mount('#app');